if (!customElements.get('modal-gridy-slider-parent')) {
  customElements.define('modal-gridy-slider-parent', class ModalGridySliderParent extends HTMLElement {
    constructor() {
      super();

      this.onBackdropClick = (event) => {
        if (!this.matches('.ing-modal.is-open') || !(event.target instanceof Element)) return;
        if (event.target.closest('.ing-detail, .gridy-arrows, [data-overlay], [data-close]')) return;
        window.Woolman?.ModalsAndDrawers?.closeModalOrDrawer(this.id);
      };
      this.onSectionUnload = (event) => {
        if (event.target.id === this.ownerSectionId ||
            `shopify-section-${event.detail?.sectionId}` === this.ownerSectionId) this.remove();
      };
    }

    connectedCallback() {
      this.ownerSectionId ||= this.closest('[id^="shopify-section-"]')?.id;
      const mainContent = document.querySelector('#MainContent');
      if (mainContent && this.parentElement !== mainContent) {
        mainContent.appendChild(this);
        return;
      }
      this.addEventListener('click', this.onBackdropClick);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onBackdropClick);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }
  })
}
